import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9232_53083)">
      <path
        d="M12.2292 3.16667H11.564C11.283 1.78977 10.0626 0.75 8.60417 0.75H7.39583C5.93738 0.75 4.71635 1.78977 4.43602 3.16667H3.77083C2.10515 3.16667 0.75 4.52181 0.75 6.1875V12.2292C0.75 13.8949 2.10515 15.25 3.77083 15.25H12.2292C13.8949 15.25 15.25 13.8949 15.25 12.2292V6.1875C15.25 4.52181 13.8949 3.16667 12.2292 3.16667ZM7.39583 1.95833H8.60417C9.392 1.95833 10.0632 2.46342 10.3128 3.16667H5.68725C5.93677 2.46342 6.608 1.95833 7.39583 1.95833ZM3.77083 4.375H12.2292C13.2285 4.375 14.0417 5.18821 14.0417 6.1875V6.79167H12.2292V6.1875C12.2292 5.854 11.9591 5.58333 11.625 5.58333C11.2909 5.58333 11.0208 5.854 11.0208 6.1875V6.79167H4.97917V6.1875C4.97917 5.854 4.7091 5.58333 4.375 5.58333C4.0409 5.58333 3.77083 5.854 3.77083 6.1875V6.79167H1.95833V6.1875C1.95833 5.18821 2.77154 4.375 3.77083 4.375ZM12.2292 14.0417H3.77083C2.77154 14.0417 1.95833 13.2285 1.95833 12.2292V8H3.77083V8.60417C3.77083 8.93767 4.0409 9.20833 4.375 9.20833C4.7091 9.20833 4.97917 8.93767 4.97917 8.60417V8H11.0208V8.60417C11.0208 8.93767 11.2909 9.20833 11.625 9.20833C11.9591 9.20833 12.2292 8.93767 12.2292 8.60417V8H14.0417V12.2292C14.0417 13.2285 13.2285 14.0417 12.2292 14.0417Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_9232_53083">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const IconCustomerManagement = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default IconCustomerManagement;
